import { WHATS_APP, ENROLLED_IN_SEQUENCE } from 'crm-activity-creator-data/interaction/InteractionTypes';
import { useHasScope } from 'crm-activity-creator-data/auth/hooks/useHasScope';
const WHATSAPP_SCOPE = 'messaging-access';
const SEQUENCES_SCOPE = 'sequences-read-access';
const WHATSAPP_UPGRADE_KEY = 'whatsapp-messaging-access-crm';
const SEQUENCES_UPGRADE_KEY = 'sequences-activity-button';
export function useButtonUpgradePath(interactionName) {
  let scope = '';
  let upgradeKey = null;
  if (interactionName === WHATS_APP) {
    // WhatsApp access enabled for marketing professional and service professional
    scope = WHATSAPP_SCOPE;
    upgradeKey = WHATSAPP_UPGRADE_KEY;
  }
  if (interactionName === ENROLLED_IN_SEQUENCE) {
    scope = SEQUENCES_SCOPE;
    upgradeKey = SEQUENCES_UPGRADE_KEY;
  }
  const hasScope = useHasScope(scope);
  if (upgradeKey) {
    return {
      hasScope,
      upgradeKey
    };
  }
  return undefined;
}